declare namespace $ {

	export class $mol_icon_power_sleep extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=sleep.view.tree.d.ts.map